<template>
  <div class="rate-percentage">
    <div
      v-for="(rate, i) in ratePercentages"
      :key="i"
      class="rate-percentage__item"
    >
      <span>{{ i + 1 }}</span>
      <i class="el-icon-star-on rate-percentage__icon" />
      <div class="rate-percentage__bar" :data-percent="rate">
        <div class="rate-percentage__progress" :style="{ width: rate }" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatePercentage',
  props: {
    ratePercentages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.rate-percentage {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: flex-end;
  padding-right: $global-padding * 2.5;

  @include breakpoint(small down) {
    align-items: center;
  }

  &__item {
    display: flex;
    align-items: center;
    font-size: $small-font-size;
    margin-bottom: $global-margin / 2;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__icon {
    margin: 0 $global-margin 0 $global-margin / 3;
    color: $lb-darker-gray;
  }

  &__bar {
    background-color: $lb-light-gray;
    border-radius: 2px;
    height: 2px;
    width: 200px;
    position: relative;

    &::after {
      content: attr(data-percent);
      position: absolute;
      left: auto;
      right: rem-calc(-45);
      top: rem-calc(-8);
      width: rem-calc(35);
      white-space: nowrap;
    }
  }

  &__progress {
    position: absolute;
    height: inherit;
    background: $lb-color-info;
    left: 0;
  }
}
</style>
